<template lang="">
    <div class="bilan" v-if="!mobileView">
        <div v-for="(bilans, key) in bilan.content" :key="key" class="bilan__content mb-5">
            <div v-if="bilans.length > 0">
                <h5 class="text-center fs-3 fw-bold">Bilan version {{ key }} du {{ bilans[0].date_validation_souscripteur }} </h5>
                <table>
                    <thead>
                        <tr>
                            <th>EXAMENS COMPLEMENTAIRES</th>
                            <th>PRIX</th>
                            <th>MEDICASURE</th>
                            <th>SOUSCRIPTEUR</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :class="validation.etat_validation_medecin == 1 ? 'etat_validation_1' : 'etat_validation_0'" v-for="(validation, index_val) in bilans" :key="'bilans'+index_val">
                          <td>{{ validation.examen }}</td>
                          <td>{{ validation.prix }}</td>
                          <td class="text-center">
                              <span class="text-success" v-if="validation.etat_validation_medecin == 1"><i
                                  class="fa fa-check green-text" aria-hidden="true"></i></span>
                              <span class="text-danger" v-else><i class="fa fa-times" aria-hidden="true"></i></span>
                          </td>
                          <td class="text-center">
                              <span v-if="validation.etat_validation_souscripteur" class="text-success"><i
                                  class="fa fa-check green-text" aria-hidden="true"></i></span>
                              <span v-else class="text-danger"><i class="fa fa-times" aria-hidden="true"></i></span>
                          </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                          <th>Total</th>
                          <th class="">{{ PraticienExamen(bilans) }}</th>
                          <th class="text-center">{{ MedecinControleExamen(bilans) }}</th>
                          <th class="text-center">{{ AssureurExamen(bilans) }}</th>
                        </tr>
                    </tfoot>
                </table>
                <div class="mt-3 mx-auto border border-primary border-2 w-50">
                    <h3 class="text-center text-success mt-1">Total validé: {{ AssureurExamen(bilans) }}</h3>
                </div>
            </div>
            <div v-else>
                <div class="box-title">Bilan version {{key}} du {{ bilans[0].date_validation_souscripteur }} </div>
                <p class="text-center mt-5">Aucune modification n'a été ajouter dans cette version</p>
            </div>
        </div>
       
        <b-row>
          <p class="text-success mt-4 ml-3">Cycle de validation: {{ version }}</p>
        </b-row>
        <b-row class="w-100 justify-content-center">
            <b-col class="mt-3 text-primary">
              <b-th class="align-middle">
                <p class="mb-0 text-center total-label mr-1">
                  Total: 
                </p>
              </b-th>
              <b-th colspan="2">
                <div class="mb-0 text-center">
                  <p class="mb-0 d-inline-block text-center">
                    <strong variant="primary">{{
                      bilan.praticien
                      }}</strong>
                  </p>
                </div>
              </b-th>
            </b-col>
            <b-col class="mt-3 text-primary">
              <b-th class="align-middle">
                <p class="mb-0 text-center total-label mr-1">
                  {{ $t("Medicasure") }}:
                </p>
              </b-th>
              <b-th colspan="2">
                <div class="mb-0 text-center">
                  <p class="mb-0 d-inline-block text-center">
                    <strong variant="primary">{{
                      bilan.medecin_controle
                      }}</strong>
                  </p>
                </div>
              </b-th>
            </b-col>
            <b-col class="mt-3 text-primary">
              <b-th class="align-middle">
                <p class="mb-0 text-center total-label mr-1">
                  {{ $t("Souscripteur") }}:
                </p>
              </b-th>
              <b-th colspan="2">
                <div class="mb-0 text-center">
                  <p class="mb-0 d-inline-block text-center">
                    <strong variant="primary">{{ bilan.assureur }}</strong>
                  </p>
                </div>
              </b-th>
            </b-col>
          </b-row>
    </div>
    <div class="bilan" v-else>
      <div v-for="(bilans, key) in bilan.content" :key="key" class="bilan__content mb-5">
        <div v-if="bilans.length > 0">
        <h3 class="text-center fs-3 fw-bold">Bilan version {{ key }} du {{ bilans[0].date_validation_souscripteur }} </h3>
        <div class="card-body" v-for="(validation, index_val) in bilans" :key="'bilans'+index_val">
          <div class="list-group-item"><p class="ligne"><span class="text-gray">EXAMENS COMPLEMENTAIRES</span>:
            <span class="font-weight-bold new-title">
              {{ validation.examen }}
            </span></p>
          </div>
          <div class="list-group-item"><p class="ligne text-gray"><span>PRIX</span>: 
            <span class="font-weight-bold new-title med_bilan">
                {{ validation.prix }}
            </span></p>
          </div>
          <div :class="validation.etat_validation_medecin == 1 ? 'etat_validation_1' : 'etat_validation_0'" class="list-group-item"><p class="ligne"><span>MEDICASURE</span>: 
            <span class="text-success med_bilan" v-if="validation.etat_validation_medecin == 1"><i class="fa fa-check green-text" aria-hidden="true"></i></span>
            <span class="text-danger med_bilan" v-else><i class="fa fa-times" aria-hidden="true"></i></span></p>
          </div>
          <div :class="validation.etat_validation_souscripteur == 1 ? 'etat_validation_1' : 'etat_validation_0'" class="list-group-item"><p class="ligne"><span>SOUSCRIPTEUR</span>: 
            <span v-if="validation.etat_validation_souscripteur" class="text-success med_bilan"><i class="fa fa-check green-text" aria-hidden="true"></i></span>
            <span v-else class="text-danger med_bilan"><i class="fa fa-times" aria-hidden="true"></i></span></p>
          </div>
          </div>
        </div>
        <div class="list-group-item">
          <p class="ligne">
            <span>Total</span>: 
            <span class="font-weight-bold text-gray med_bilan">
                <span class="">{{ PraticienExamen(bilans) }}</span>
            </span>
          </p>
        </div>
        <div class="list-group-item">
          <p class="ligne">
            <span>Medicasure</span>: 
            <span class="font-weight-bold text-gray med_bilan">
                <span class="text-center">{{ MedecinControleExamen(bilans) }}</span>
            </span>
          </p>
        </div>
        <div class="list-group-item">
          <p class="ligne">
            <span>Souscripteur</span>: 
            <span class="font-weight-bold text-gray med_bilan">
                <span class="text-center">{{ AssureurExamen(bilans) }}</span>
            </span>
          </p>
        </div>
        <div class="mb-5">
            <h3 class="text-center text-success mt-3">Total validé: {{ AssureurExamen(bilans) }}</h3>
        </div>
        <hr>
      </div>

      <div>
          <!-- <h3 class="text-center text-success mt-5">Total validé</h3>
          <h3 class="text-center text-success mt-5">Total validé</h3> -->
      </div>
    </div>

</template>
<script>
import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
import moment from "moment";
export default {
    name: "BilanVersionValidationParLigneTemps",
    computed: {},
    props: ['ligne_temps', 'dossier_medical_slug'],
    data() {
        return {
          mobileView: true,
          validation_financiere_ligne_temps: [],
          total_validation_financiere: {},
          bilan: {title: "", praticien: "", medecin_controle: "", assureur: "", content: ""},
          version: 1,
          bilan_final: ''
        }
    },
    computed: {
      // a computed getter
      praticien_prix() {
        // `this` points to the component instance
        return this.PraticienExamen(this.bilan_final)
      }
    },

    methods: {
        recupartion_du_prix(data_bilan){
          this.bilan_final = data_bilan;
          this.bilan.praticien = 
          this.bilan.medecin_controle = this.MedecinControleExamen(data_bilan)
          this.bilan.assureur = this.AssureurExamen(data_bilan)
          // console.log("praticien ", this.PraticienExamen(data_bilan))
        },
        handleView() {
            this.mobileView = window.innerWidth < 991;
        },
        displayNumber(value) {
            return Number(value).toLocaleString("fr") + " XAF";
        },
        PraticienExamen: function(data) {
            return this.displayNumber(data.reduce((accumulator, validation) => {
            return accumulator + Number(validation.prix);
            }, 0))
        },
        MedecinControleExamen: function(data) {
            return this.displayNumber(data.filter(item => item.etat_validation_medecin).reduce((accumulator, validation) => {
            return accumulator + Number(validation.prix);
            }, 0));
        },
        AssureurExamen: function(data) {
            return this.displayNumber(data.filter(item => item.etat_validation_souscripteur).reduce((accumulator, validation) => {
            return accumulator + Number(validation.prix);
            }, 0));
        },
        formattedDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format("DD-MM-YYYY");
            } else {
                return date;
            }
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        getDetails(ligne_temps){
            axios.get(AppConfig.apiUrl+`/ligne_temps/bilan/${ligne_temps.id}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
            let data_bilan = [], bilan_ligne = [];
            for (const [key, value] of Object.entries(res.data)) {
              value.forEach(item => {
                let find = data_bilan.find(examen => examen.id == item.id);
                if(find == null){
                  data_bilan = [...data_bilan, item];
                }
                this.version = item.version
              });
              bilan_ligne = [...bilan_ligne, value];
            }
            this.bilan.title = `${ligne_temps.motif}`
            this.bilan.content = res.data
            this.bilan.praticien = this.PraticienExamen(data_bilan)
            this.bilan.medecin_controle = this.MedecinControleExamen(bilan_ligne[bilan_ligne.length -1])
            this.bilan.assureur = this.AssureurExamen(bilan_ligne[bilan_ligne.length -1])
                
            }).catch(error => {
            })
        },
       
    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
      this.getDetails(this.ligne_temps);
      //this.computeBilanGlobal(this.dossier_medical_slug);
    }
}
</script>
<style lang="">
    
</style>